
import axios from 'axios';

const jwt = localStorage.getItem('@mob:jwt');

const api = axios.create({
    //baseURL: 'http://localhost/_mob/api21/',
    baseURL: 'https://metodobillings.com.br/api2.1/',
    timeout: 5000,
    headers: {         
        'Authorization': 'Bearer '+ jwt,
        'Content-Type': 'application/json',
        'accept': 'application/json'
    }
})

// Set the AUTH token for any request
api.interceptors.request.use(function (config) {    
    const jwt = localStorage.getItem('@mob:jwt');
    config.headers.Authorization =  jwt ? `Bearer ${jwt}` : '';
    return config;
});

export {api};
